








































import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';

import { mapGetters } from 'vuex';

import { FilterTypeEnum } from '../../enums';

import { Dictionary, Filter, RegularFilter, RegularFilterSelectedValues } from '../../models';

import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import Schedule from '../crud/schedule.component.vue';
import RegularFilterSelector from '../filters/regular-filter-selector.component.vue';
import { UiButton } from '../keen-ui';

export default {
  name: 'edit-attribute-form',
  components: {
    RegularFilterSelector,
    UiButton,
    Schedule
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    })
  },
  data: function () {
    const messages = this.$epb.messages.tools.attributesRanking;
    return {
      updates: {
        filters: {},
        schedule: {
          activationDate: undefined,
          deactivationDate: undefined
        }
      },
      messages: messages
    };
  },
  props: {
    attribute: Object
  },
  methods: {
    onAccept: function (): void {
      this.$emit('update', this.updates);
      this.$emit('close');
    },
    onFilterChange: function (filter: RegularFilter, selectedValues: RegularFilterSelectedValues): void {
      const itemfilterValues = selectedValues.map((selectedValue: string) => {
        const selectedValueConfig = filter.config.values.find((filterValueConfig: RegularFilterValueConfig) =>
          (filterValueConfig.id === selectedValue));
        return (selectedValueConfig.taggingId || selectedValueConfig.id);
      });
      this.updates.filters[(filter.config.toolingId || filter.config.id)].selectedValues =
        (filter.config.multiselectDisabled ? itemfilterValues[0] : itemfilterValues);
    },
    initUpdates: function () {
      const initFilters: Dictionary<Filter> = {};
      Object.values(this.context.filters)
        .filter((filter: Filter) => ((filter.config.type === FilterTypeEnum.REGULAR) &&
          (((filter as RegularFilter).config.toolingId || filter.config.id) !== 'lang')))
        .forEach((filter: RegularFilter) => {
          initFilters[(filter.config.toolingId || filter.config.id)] = {
            config: {
              ...filter.config,
              mandatory: true,
              multiselectDisabled: false
            },
            selectedValues: (this.attribute.filters[filter.config.toolingId || filter.config.id] || [])
          };
        });
      this.updates.filters = initFilters;
      Object.assign(this.updates.schedule, this.attribute.schedule);
    }
  },
  watch: {
    'attribute': {
      handler: function (): void {
        this.initUpdates();
      },
      deep: true,
      immediate: true
    }
  }
};
